import { namespace } from 'vuex-class';
import { IImportProgressState } from '@/dealroom/add-page/import-progress/store/import-progress.types';

export const ImportProgress = namespace('dealroom/addPage/importProgress');

export const state: IImportProgressState = {
  importIndex: null,
  type: null,
  name: null,
  error: null,
  progress: {
    currentStep: null,
    totalPageCount: null,
    pages: [],
  },
};

export enum EImportProgressAction {
  InitializeImport = 'initializeImport',
  UpdateImportProgress = 'updateImportProgress',

  CompleteTemplateImport = 'completeTemplateImport',

  Reset = 'reset',

  ImportFailed = 'importFailed',
}

export enum EImportProgressMutation {
  SetInitialized = 'setInitialized',
  SetProgress = 'setProgress',
  SetState = 'setState',
}

export enum EImportProgressGetter {
  ImportCompleted = 'importCompleted',
}
